import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { WorkflowActionInputComponent } from "./workflow.action.input.component";
import { SystemActionComponent } from "./abstract.system.action.component";
import { WorkflowContactRoleFieldRefsComponent } from "./workflow.contact.role.field.refs.component";

@Component({
    standalone: true,
    selector: "s25-ng-workflow-add-contact-roles-action",
    template: `
        <div class="form-group">
            <small class="form-text auto-collect-info">
                Contact/role pairs from ORG_CONTACT_ROLE form fields are merged with the optional field references
                below.
            </small>
        </div>

        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['organizationIdField']?.inputValue"
            (valueChange)="setInputValue('organizationIdField', $event)"
            [label]="'Organization ID Field'"
            [type]="'text'"
            [required]="false"
            [help]="
                'For forms without an implied organization, map a form field containing the organization ID (e.g., $CNET-123-ORG_ID). Forms with an implied organization automatically have organization ID available.'
            "
            [acceptedAnswerTypes]="acceptedFor('organizationIdField')"
        />

        <s25-ng-workflow-contact-role-field-refs
            [(inputs)]="inputs"
            (changed)="changed.emit()"
            [inputIdGenerator]="inputIdGenerator()"
        />
    `,
    styles: `
        .form-group {
            margin-bottom: 16px;
        }

        .form-text {
            color: #666;
            font-size: 12px;
            margin-top: 4px;
            display: block;
        }

        .auto-collect-info {
            margin-bottom: 0;
        }

        .system-input {
            margin-bottom: 16px;
        }

        .system-input:last-child {
            margin-bottom: 0;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [WorkflowActionInputComponent, WorkflowContactRoleFieldRefsComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddContactRolesActionComponent extends SystemActionComponent {
    protected readonly actionCode = "ADD_CONTACT_ROLES" as const;
}
